import { SVGProps } from "react";

export function NewUserSignupIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      fill="none"
      viewBox="0 0 33 32"
      {...props}
    >
      <path
        stroke="#FBFDFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.01 20c3.927-1.76 6.266-1.796 10.666 0"
      ></path>
      <ellipse
        cx="4"
        cy="4"
        stroke="#FBFDFF"
        strokeLinejoin="round"
        strokeWidth="1.5"
        rx="4"
        ry="4"
        transform="matrix(1 0 0 -1 11.342 14.667)"
      ></ellipse>
      <path
        stroke="#FBFDFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M27.045 17.333c.194-.857.297-1.75.297-2.666 0-6.628-5.372-12-12-12-6.627 0-12 5.372-12 12 0 6.627 5.373 12 12 12 .917 0 1.81-.103 2.667-.298"
      ></path>
      <path
        stroke="#FBFDFF"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M24.676 21.333v5.334M27.342 24H22.01"
      ></path>
    </svg>
  );
}

